import request from '@/utils/request'

export function login (data) {
    return request({
        url: '/login',
        method: 'post',
        data
    })
}
// 首页统计接口
export function index_statics (data) {
    return request({
        url: '/index/get_total',
        method: 'get'
    })
}
// 首页统计图接口
export function index_legend_statics (data) {
    return request({
        url: '/index/get_statics',
        method: 'get',
        params: data
    })
}

// 统计注册用户数量
export function index_regs (data) {
    return request({
        url: '/index/get_regs',
        method: 'get',
        params: data
    })
}

// 统计注册用户数量
export function count_packages (data) {
    return request({
        url: '/index/count_packages',
        method: 'get',
        params: data
    })
}

//用户列表
export function get_list (data) {
    return request({
        url: '/user/get_list',
        method: 'get',
        params: data
    })
}
//禁用或开启用户
export function edit_status (data) {
    return request({
        url: '/user/edit_status',
        method: 'put',
        data
    })
}
// 创建员工修改员工
export function add_personnel(data) {
    return request({
        url: '/user/add_personnel',
        method: 'put',
        params: data
    })
}
//员工列表
export function personnel_list(data) {
    return request({
        url: '/user/personnel_list',
        method: 'get',
        params: data
    })
}
//删除员工
export function del_personnel(data) {
    return request({
        url: '/user/del_personnel',
        method: 'DELETE',
        params: data
    })
}
//产品套餐列表
export function goods_list(data) {
    return request({
        url: '/product/goods_list',
        method: 'get',
        params: data
    })
}

//插件列表
export function plugin_list(data) {
    return request({
        url: '/product/plugin_list',
        method: 'get',
        params: data
    })
}
//产品列表
export function application_list(data) {
    return request({
        url: '/product/application_list',
        method: 'get',
        params: data
    })
}
//创建套餐----修改套餐
export function update_package(data) {
    return request({
        url: '/product/update_package',
        method: 'post',
        data
    })
}
// package_plugin
// http://zhongtai.com/adminapi/user/package_plugin
//获取已购产品对应的插件
export function package_plugin(data) {
    return request({
        url: '/user/package_plugin',
        method: 'post',
        data
    })
}
//删除套餐
export function del_package(data) {
    return request({
        url: '/product/del_package',
        method: 'DELETE',
        params: data
    })
}
//订单列表
export function orders_list(data) {
    return request({
        url: '/product/orders_list',
        method: 'get',
        params: data
    })
}
// 删除订单
export function del_orders(data) {
    return request({
        url: '/product/del_orders',
        method: 'DELETE',
        params: data
    })
}
// 支付订单-修改订单 
export function pay_orders(data) {
    return request({
        url: '/product/pay_orders',
        method: 'put',
        params: data
    })
}

//激活码列表
export function authorlze_list(data) {
    return request({
        url: '/empower/authorlze_list',
        method: 'get',
        params: data
    })
}
//创建-修改激活码
export function update_authorlze(data) {
    return request({
        url: '/empower/update_authorlze',
        method: 'put',
        params: data
    })
}
//删除激活码
export function authorlze_del(data) {
    return request({
        url: '/empower/authorlze_del',
        method: 'DELETE',
        params: data
    })
}
// 查看对应套餐待支付用户
export function package_orderuser(data) {
    return request({
        url: '/empower/package_orderuser',
        method: 'get',
        params: data
    })
}
// 激活用户订单
export function update_order_status(data) {
    return request({
        url: '/empower/update_order_status',
        method: 'put',
        params: data
    })
}
// http://192.168.1.201:118/adminapi/empower/update_prohibit?activation_id=5&status=1
//禁用开启激活码
export function update_prohibit(data) {
    return request({
        url: '/empower/update_prohibit',
        method: 'put',
        params: data
    })
}
// http://192.168.1.201:118/adminapi/user/get_city
//城市列表
export function get_city(data) {
    return request({
        url: '/user/get_city',
        method: 'get',
        params: data
    })
}
// http://192.168.1.201:118/adminapi/user/update_userinfo
//创建用户-修改用户
export function update_userinfo(data) {
    return request({
        url: '/user/update_userinfo',
        method: 'post',
        data
    })
}
// http://192.168.1.201:118/adminapi/user/get_good_splugin?store_id=24
//已购买的产品及插件
export function get_good_splugin(data) {
    return request({
        url: '/user/get_good_splugin',
        method: 'get',
        params: data
    })
}
// http://192.168.1.201:118/adminapi/user/edit_prohibit?goods_id=1&status=0
//禁用用户购买的产品插件
export function edit_prohibit(data) {
    return request({
        url: '/user/edit_prohibit',
        method: 'put',
        params: data
    })
}
// 获取订单状态
// get_orderstatus
// http://192.168.1.201:118/adminapi/product/orders_list?order_no=&uid=
export function get_orderstatus(data) {
    return request({
        url: '/product/get_orderstatus',
        method: 'get',
        params: data
    })
}
// http://192.168.1.201:118/adminapi/user/get_operation_record?goods_id=892&limit=20&page=1
//插件操作记录
export function get_operation_record(data) {
    return request({
        url: '/user/get_operation_record',
        method: 'get',
        params: data
    })
}
// http://192.168.1.201:118/adminapi/user/udate_product_version?goods_id=180&plugin_id=4
//插件操作记录
export function udate_product_version(data) {
    return request({
        url: '/user/udate_product_version',
        method: 'put',
        params: data
    })
}
// http://192.168.1.201:118/adminapi/user/enter_system?uid=38
// 进入系统
export function enter_system(data) {
    return request({
        url: '/user/enter_system',
        method: 'get',
        params: data
    })
}
// http://192.168.1.201:118/adminapi/user/del_product?uid=45&order_id=512
//删除产品
export function del_product(data) {
    return request({
        url: '/user/del_product',
        method: 'DELETE',
        params: data
    })
}
// http://192.168.1.201:118/adminapi/product/get_signdomain_orders?type=1&limit=20&page=1&status=0&application_id=1&start_time=&end_time=&title=&phone=
// 审核订单列表
export function get_signdomain_orders(data) {
    return request({
        url: '/product/get_signdomain_orders',
        method: 'get',
        params: data
    })
}
// http://192.168.1.201:118/adminapi/product/signdomain/edit_status?id=10&status=1&failure_reason=
// 审核订单
export function go_edit_status(data) {
    return request({
        url: '/product/signdomain/edit_status',
        method: 'put',
        params: data
    })
}
// 获取短信通道信息
// http://192.168.1.201:118/adminapi/user/get_smschannel_info
export function get_smschannel_info(data) {
    return request({
        url: '/user/get_smschannel_info',
        method: 'get',
        params: data
    })
}
// 短信通道开关
// http://192.168.1.201:118/adminapi/user/sms_channel_edit?status=0&application_id=3
export function sms_channel_edit(data) {
    return request({
        url: '/user/sms_channel_edit',
        method: 'put',
        params: data
    })
}

// edit_pwd
// http://192.168.1.201:118/adminapi/edit_pwd
export function edit_pwd(data) {
    return request({
        url: '/edit_pwd',
        method: 'post',
        data
    })
}

// http://192.168.1.201:118/adminapi/user/get_account_school?uid=2&application_id=3
// 获取账号所有学校
export function get_account_school(data) {
    return request({
        url: '/user/get_account_school',
        method: 'get',
        params: data
    })
}
